var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.22.068A14.41 14.41 0 0 0 .79 14.5c0 7.948 6.444 14.432 14.43 14.432 7.946 0 14.43-6.445 14.43-14.432C29.61 6.513 23.166.068 15.22.068Zm0 27.599c-7.274 0-13.165-5.892-13.165-13.167 0-7.275 5.89-13.166 13.165-13.166 7.274 0 13.165 5.891 13.165 13.166s-5.89 13.167-13.165 13.167Z",
    fill: "url(#profile_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 26.244c6.485 0 11.742-5.258 11.742-11.743 0-6.486-5.257-11.744-11.742-11.744-6.485 0-11.741 5.258-11.741 11.744 0 6.485 5.256 11.743 11.741 11.743Z",
    fill: "#DFDDDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 26.718c6.747 0 12.216-5.47 12.216-12.218 0-6.747-5.47-12.217-12.216-12.217-6.747 0-12.216 5.47-12.216 12.217 0 6.748 5.47 12.218 12.216 12.218Z",
    fill: "#CCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 26.244c6.485 0 11.742-5.258 11.742-11.743 0-6.486-5.257-11.744-11.742-11.744-6.485 0-11.741 5.258-11.741 11.744 0 6.485 5.256 11.743 11.741 11.743Z",
    fill: "#DFDDDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.136 17.94c-.079.119-.079.237-.118.395-.119.554-.633.87-1.068 1.147-1.542.91-3.083 1.78-4.586 2.728a11.704 11.704 0 0 0 8.856 4.033c3.716 0 7.037-1.74 9.172-4.428l-3.914-2.017c-.316-.158-.633-.316-.949-.435-.237-.079-.514-.197-.712-.355-.316-.277-.237-.712-.316-1.107-.04-.12-.04-.198-.118-.277-.159-.198-.475-.198-.633-.356-.119-.119-.119-.277-.119-.396 0-.079 0-.197.04-.276.04-.08.158-.159.277-.198.079-.08.197-.158.276-.198.198-.158.396-.276.475-.514.158-.356.237-.751.277-1.107.04-.395-.04-.87.118-1.226.158-.355.514-.514.554-.909.079-.356 0-.79-.158-1.147-.08-.158-.159-.237-.277-.395-.08-.158-.04-.316 0-.474.079-.475-.04-.95-.158-1.424-.04-.158-.08-.356-.119-.514-.119-.356-.395-.633-.672-.83l-.474-.237c-.159-.119-.356-.198-.514-.277-.396-.158-.83-.317-1.265-.435-.83-.198-1.74-.237-2.53.118-.396.198-.791.554-.83.989a1.467 1.467 0 0 0-1.582.633c-.237.435-.277.909-.277 1.383.04.435.158.83.237 1.266 0 .118.04.237-.04.356-.039.079-.157.118-.197.197-.04.08-.04.158-.04.198-.039.553-.039 1.107.238 1.581.04.08.079.12.158.159a.3.3 0 0 0 .158.079c.237.158.395.435.514.672.08.237.08.514.119.79.04.198.118.436.197.633.08.159.158.277.317.396.118.118.197.276.395.316 0 .04.04.08.04.119.039.079.039.197.039.316 0 .198.04.475-.119.633-.197.237-.553.158-.672.395Z",
    fill: "#546F7A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "profile_svg__a",
    x1: 5.269,
    y1: 25.015,
    x2: 25.252,
    y2: 3.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEA542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#851A92"
  })))));
};

export default SvgProfile;